import { render } from "./RuiOpenInNew.vue?vue&type=template&id=129b9d32"
const script = {}
script.render = render

export default script